import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { DomSanitizer } from '@angular/platform-browser';
import { LeapmotorElementDTO } from '../../../models/elements-dto';
import { ElementType } from '../../../enums/elements';
import { ElementService } from '../../../services/elements-service';
import { TrackingService } from '../../../services/tracking.service';
import { LogType } from '../../../enums/logtype';

@Component({
  selector: 'app-shortcut',
  templateUrl: './shortcut.component.html',
  styleUrls: ['./shortcut.component.scss'],
})
export class ShortcutComponent implements OnInit {
  data: LeapmotorElementDTO[] = [];
  type =  ElementType.AccesosDirectos;

  constructor(private elementService: ElementService, private trackingService: TrackingService) { }

  ngOnInit(): void {

    this.elementService.GetLeapmotorElementLst(this.type).subscribe(resp => {
      this.data = resp;
    }, (err) => {
      Swal.fire({
        icon: 'info',
        title: 'Cargando...',
        text: 'espere por favor…'
      });
    });
  }

  TrackBanner(id:string) {
    this.trackingService.trackElement(id, LogType.Nav).subscribe();
  }
}
